import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mainPrice'
})
export class MainPricePipe implements PipeTransform {

  transform(value: number): string {
    let pr = value.toString().split('.');
    return pr[0];
  }

}
